/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Models the NewSPMFileUploadContents
 *
 * @class NewSPMFileUploadContents
 */
class NewSPMFileUploadContents {
  /**
   * Creates an instance of NewSPMFileUploadContents.
   * @param {*} json
   * @memberof NewSPMFileUploadContents
   */
  constructor(json = null) {
    if (json) {
      // string
      this.data = json.data;
    }
  }
}

/**
 * Models the SPMFileDownloadContents
 *
 * @class SPMFileDownloadContents
 */
class SPMFileDownloadContents {
  /**
   * Creates an instance of SPMFileDownloadContents.
   * @param {*} json
   * @memberof SPMFileDownloadContents
   */
  constructor(json = null) {
    if (json) {
      // string
      this.data = json.data;
    }
  }
}

export default {
  NewSPMFileUploadContents,

  SPMFileDownloadContents,
};
